import { cn } from './cn'

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
	size?: 'sm' | 'md' | 'lg'
}

export function Spinner({ size = 'md', className, ...rest }: SpinnerProps) {
	return (
		<span
			role="status"
			aria-label="Loading"
			className={cn(
				'spinner-refined',
				size === 'sm' && 'spinner-refined-sm',
				size === 'lg' && 'spinner-refined-lg',
				className,
			)}
			{...rest}
		/>
	)
}
